var Playtime = {
    init: function() {
        $.fn.playtime = function() {
            var el = $(this);
            
            el
            .on('update.playtime', function() {
                var el = $(this);
                var now = new Date();
                var offset = now.getTimezoneOffset() * 60000;
                var data = el.data('playtime').split(' ');
                
                var start = (new Date(data[0])).getTime() - offset;
                var end = (new Date(data[1])).getTime() - offset;
                now = now.getTime() - offset;
                
                var progress = (now - start) / ((end - start) / 100);
                
                el.toggleClass('active', now > start && now < end).width(progress + '%');
                
                // ajax call
                var ajax = el.parents('[data-ajax-url]');
                if (progress > 100 && ajax.length) {
                    AjaxCalls.work(ajax, ajax.data('ajax-url'));
                }
            })
            .trigger('update.playtime');
            
            setInterval(function() {
                el.trigger('update.playtime');
            }, 60000);
        };
        $('[data-playtime]').playtime();
    }
}

module.exports = Playtime;